import layout from '@/components/layout/layout'
import {localLanguageVal} from "@/utils/autoScale";
let localLanguage=localLanguageVal()
const about = {
  path: '',
  name: 'about',
    redirect: '',
  component: layout,
  children: [{
    path:localLanguage+'/about',
    redirect: '',
      name: 'about',
    component: () => import('@/views/about/index')
  },{
    path: localLanguage+'/culture',
    redirect: '',
    name: 'culture',
    component: () => import('@/views/about/culture')
  },{
      path: localLanguage+'/news',
      redirect: '',
      name: 'about',
      component: () => import('@/views/about/news')
  },{
      path: localLanguage+'/news/detail/:id',
      redirect: '',
      name: 'about',
      component: () => import('@/views/about/detail')
  },{
      path: localLanguage+'/prize',
      redirect: '',
      name: 'about',
      component: () => import('@/views/about/prize')
  },{
      path: localLanguage+'/download',
      redirect: '',
      name: 'about',
      component: () => import('@/views/about/download')
  }]
}

export default about
